import gql from 'graphql-tag'

export default gql`{
  id
  description
  name
  permissions {
    id
    name
  }
  status
}`